import type { SyntheticEvent } from 'react';

import reactParser, { type HTMLReactParserOptions, type domToReact } from 'html-react-parser';

import replaceParser from './replaceParser';

export type ReactHTMLReplaceOptions = {
  /** The heading item id to build the table of contents on blog posts */
  headingItemId?: string;
  /** Applies specific styles if true */
  isDiscovery?: boolean;
  /** Only run the TOC data */
  isTOC?: boolean;
  /** The onLoad function for images */
  onLoad?: (e: SyntheticEvent<HTMLImageElement>) => void;
  /** Changes the top-level tag of the data, to avoid malformed nested tags */
  replaceTag?: string;
};

export type ReactHTMLParserOptions = {
  /** The parser options from `html-react-parser` */
  parser?: HTMLReactParserOptions;
  /** Custom parser options for custom logic */
  replaceOptions?: ReactHTMLReplaceOptions;
};

export type ReactHTMLParser = (
  /** The HTML string to parse */
  html?: string | null,
  /** React HTML Parser & Custom Options to pass to HTML parser */
  options?: ReactHTMLParserOptions,
) => ReturnType<typeof domToReact>;

const reactHTMLParser: ReactHTMLParser = (
  html,
  options = {
    parser: {},
    replaceOptions: {},
  },
) =>
  reactParser(html || '', {
    ...options?.parser,
    replace: (domNode, index) => replaceParser(domNode, index, options?.replaceOptions),
  });

export default reactHTMLParser;
